export const GA_CATEGORY = 'category';
export const GA_ACTION = 'action';
export const GA_LABEL = 'label';
export const META_DATA = 'metaData';
export const GOOGLE_ANALYTICS_EVENT_TRACKING = 'GOOGLE_ANALYTICS_EVENT_TRACKING';

export const GA_CATEGORY_USER = 'user';
export const GA_CATEGORY_SYSTEM = 'system';
export const GA_CATEGORY_ARGOS = 'argos';
export const GA_CATEGORY_MDP = 'my digital footprint';
export const GA_CATEGORY_REPORTS_COLLABORATION = 'reports collaboration';
export const GA_CATEGORY_FORENSICS = 'forensics';
export const GA_CATEGORY_ALERTS = 'alerts';
export const GA_CATEGORY_KNOWLEDGE_BASE = 'knowledge base';
export const GA_CATEGORY_INTEGRATIONS = 'integrations';
export const GA_CATEGORY_IOC = 'ioc';
export const GA_CATEGORY_CVE = 'cve';
export const GA_CATEGORY_NOTIFICATIONS = 'notifications';

export const gaActionPrefixClickedOn = onWhatClicked => `Clicked on ${onWhatClicked}`;
export const gaActionPrefixSearchedIn = inWhereSearched => `Searched in ${inWhereSearched}`;
